import { Directive } from "@angular/core";

@Directive()
export abstract class BaseDataModelServiceComponent {

    protected openModal(eventFl: Boolean, dataToProcess: any): Boolean {
        if (dataToProcess)
            this.customOnModalOpen(dataToProcess);

        return !eventFl;
    }

    protected closeModal(eventFl: Boolean, dataToProcess: any): Boolean {
        if (dataToProcess)
            this.customOnModalClose(dataToProcess);

        return !eventFl;
    }

    /**If any custom changes need to be performed on closing the modal then override this function*/
    protected customOnModalClose(dataToProcess): void { };

    /**If any custom changes need to be performed on opening the modal then override this function*/
    protected customOnModalOpen(dataToProcess): void { };

}